import { render } from "./Step2EventDetails.vue?vue&type=template&id=1d38b821&scoped=true"
import script from "./Step2EventDetails.vue?vue&type=script&lang=js"
export * from "./Step2EventDetails.vue?vue&type=script&lang=js"

import "./Step2EventDetails.vue?vue&type=style&index=0&id=1d38b821&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d38b821"]])

export default __exports__